<app-content *ngIf="page$ | async as page" [page]="page"></app-content>
